/**
 * Build the payload sent to the `searchPayers` cloud function.
 * Only includes `clinicId` when the caller provided a non-empty string —
 * the cloud function treats its absence as "skip usage enrichment" and
 * returns the base payer list unchanged.
 */
export function buildPayerSearchPayload(
  input: { query?: string } | undefined,
  clinicId: string | undefined,
): { query?: string; clinicId?: string } {
  if (clinicId) return { ...(input ?? {}), clinicId }
  return input ?? {}
}
